<template>
  <div id="cidadaos_visitados" class="row">
    <div class="col-md-12">
      <SelectsV2
        v-if="enableSelect == 1"
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
        :disabledMicroArea="loading"
      />
      <SelectsV2
        v-if="enableSelect == 2"
        :activeSelectEquipes="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
        :disabledMicroArea="loading"
      />
    </div>
    <div class="col-md-12">
      <b-tabs fill class="esus-feedback-tabs tabs-auto" v-model="tabsActive">
        <b-tab title="Lista" active>
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>
          <div class="row">
            <div class="col-md-12">
              <div class="info-table">
                <div class="info-table-item">
                  <Subtitle
                    @exibirVermelhos="handleExibirVermelhos"
                    @exibirVerdes="handleExibirVerdes"
                    :setColor="setColor"
                    @resetColor="resetColor"
                    :setRed="exibirCadastrosVermelhos"
                    :setGreen="exibirCadastrosVerdes"
                  ></Subtitle>
                </div>
                <div class="select-visita info-table-item">
                  <vue-select
                    :options="visita_opcoes"
                    label="visita"
                    placeholder="Status visita"
                    v-model="visita"
                    @input="
                      visita !== null
                        ? filtros(
                            exibirCadastrosVermelhos,
                            exibirCadastrosVerdes
                          )
                        : filtros(
                            exibirCadastrosVermelhos,
                            exibirCadastrosVerdes
                          )
                    "
                    :clearable="true"
                  >
                    <template slot="option" slot-scope="option">
                      {{ option.visita }}
                    </template>
                    <div slot="no-options">Não há opções correspondentes</div>
                  </vue-select>
                </div>
                <div class="info-table-item">
                  <download-files
                    :callback-pdf="generatePdf"
                    :data="displayedCadastros"
                    :fields="dataFields"
                    name="cidadaos-visitados"
                  >
                  </download-files>
                </div>
              </div>
              <tabela-cadastros
                ref="table"
                :cadastros="displayedCadastros"
                :loading="loading"
                :ultimaAtualizacaoSincronizadorC="
                  ultimaAtualizacaoSincronizadorC
                "
                @filterSearch="filterSearch($event)"
              ></tabela-cadastros>
            </div>
          </div>
        </b-tab>
        <b-tab title="Resultado">
          <template v-slot:title>
            <i class="icofont-mathematical-alt-1"></i> Resultado
          </template>
          <div class="row">
            <div class="col-md-12">
              <div class="box mt-0">
                <div class="box-header">
                  <h4 class="box-title">
                    <i class="icofont-listine-dots"></i> Cidadãos visitados
                  </h4>
                </div>
                <div class="box-body">
                  <table
                    class="table table-responsive table-bordered text-center table2"
                    id="table"
                  >
                    <thead>
                      <tr>
                        <th>Por</th>
                        <th>Total</th>
                        <th>
                          A visitar / Dia
                          <span
                            v-b-tooltip.hover
                            title="Estimativa para visitar todos os cidadãos em 30 dias"
                            class="icon-tooltip"
                          >
                            <i class="icofont-info-circle"></i>
                          </span>
                        </th>
                        <th>
                          Menos de 30 dias
                          <span
                            v-b-tooltip.hover
                            title="Cidadãos visitados no últimos 30 dias"
                            class="icon-tooltip"
                          >
                            <i class="icofont-info-circle"></i>
                          </span>
                        </th>
                        <th>
                          Mais de 30 dias
                          <span
                            v-b-tooltip.hover
                            title="Cidadãos visitados há mais de 30 dias"
                            class="icon-tooltip"
                          >
                            <i class="icofont-info-circle"></i>
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Município</td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="dadosResultadoMunicipio.denominador"
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="
                              Math.round(
                                dadosResultadoMunicipio.denominador / 21
                              )
                            "
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center green font-weight-bold">
                          <loader
                            :value="`
                                ${dadosResultadoMunicipio.numerador}
                                (${dadosResultadoMunicipio.resultado}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                        <td class="text-center red font-weight-bold">
                          <loader
                            :value="`
                                ${
                                  dadosResultadoMunicipio.denominador -
                                  dadosResultadoMunicipio.numerador
                                }

                                (${100 - dadosResultadoMunicipio.resultado}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                      </tr>
                      <tr v-if="equipe != ''">
                        <td>Equipe</td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="dadosResultadoEquipe.denominador"
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="
                              Math.round(dadosResultadoEquipe.denominador / 21)
                            "
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center green font-weight-bold">
                          <loader
                            :value="`
                                ${dadosResultadoEquipe.numerador}
                                (${dadosResultadoEquipe.resultado}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                        <td class="text-center red font-weight-bold">
                          <loader
                            :value="`
                                ${
                                  dadosResultadoEquipe.denominador -
                                  dadosResultadoEquipe.numerador
                                }

                                (${100 - dadosResultadoEquipe.resultado}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                      </tr>
                      <tr v-if="micro_area != ''">
                        <td>Microárea {{ micro_area }}</td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="dadosResultadoMicroArea.denominador"
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="
                              Math.round(
                                dadosResultadoMicroArea.denominador / 21
                              )
                            "
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center green font-weight-bold">
                          <loader
                            :value="`
                                ${dadosResultadoMicroArea.numerador}
                                (${dadosResultadoMicroArea.resultado}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                        <td class="text-center red font-weight-bold">
                          <loader
                            :value="`
                                ${
                                  dadosResultadoMicroArea.denominador -
                                  dadosResultadoMicroArea.numerador
                                }

                                (${100 - dadosResultadoMicroArea.resultado}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <FonteSincronizadorC />
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Mapa" @click="loadMap()">
          <template v-slot:title>
            <i class="icofont-ui-map"></i> Mapa
          </template>
          <div class="row mt-4">
            <div class="col-12">
              <div class="info-table">
                <div class="info-table-item">
                  <Subtitle
                    @exibirVermelhos="handleExibirVermelhos"
                    @exibirVerdes="handleExibirVerdes"
                    :setColor="setColor"
                    @resetColor="resetColor"
                    :setRed="exibirCadastrosVermelhos"
                    :setGreen="exibirCadastrosVerdes"
                  ></Subtitle>
                </div>
                <div class="select-visita info-table-item">
                  <vue-select
                    :options="visita_opcoes"
                    label="visita"
                    placeholder="Status visita"
                    v-model="visita"
                    @input="
                      visita !== null
                        ? filtros(
                            exibirCadastrosVermelhos,
                            exibirCadastrosVerdes
                          )
                        : filtros(
                            exibirCadastrosVermelhos,
                            exibirCadastrosVerdes
                          )
                    "
                    :clearable="true"
                  >
                    <template slot="option" slot-scope="option">
                      {{ option.visita }}
                    </template>
                    <div slot="no-options">Não há opções correspondentes</div>
                  </vue-select>
                </div>
              </div>
            </div>
            <div class="col-12 mapa">
              <l-map
                :zoom.sync="zoom"
                :center="center"
                style="height: 500px; width: 100%"
                ref="map"
                :options="{ zoomControl: false }"
              >
                <l-tile-layer :url="url" :attribution="attribution" />
                <l-control-zoom position="bottomright"></l-control-zoom>
                <!--  <l-marker
                      :lat-lng="[`${markerLatLng[0]}`, `${markerLatLng[1]}`]"
                      :icon="iconColor('2022-04-12', '1')"
                    >
                    </l-marker> -->

                <l-marker
                  v-for="(pessoa, index) in cadastrosMapa"
                  :key="'marker-' + index"
                  :lat-lng="[
                    `${pessoa.lat ? pessoa.lat : '0'}`,
                    `${pessoa.lng ? pessoa.lng : '0'}`,
                  ]"
                  :icon="
                    iconColor(
                      pessoa.dt_ultima_visita,
                      pessoa.id_desfecho,
                      pessoa.lat,
                      pessoa.lng
                    )
                  "
                >
                  <l-tooltip>
                    <div class="tooltip-latlgn">
                      {{ pessoa.no_cidadao }}
                    </div>
                  </l-tooltip>
                </l-marker>
              </l-map>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import TabelaCadastros from './TabelaCadastros.vue'
import * as Functions from './functions.js'
import mapa from '@/pages/PrevineBrasil/arquivos/mapa_ranking_regional'
import { mask } from 'vue-the-mask'
import Subtitle from './Subtitle'
import { coordinates } from '@/pages/PrevineBrasil/coordinates'
import {
  LMap,
  LCircle,
  LTileLayer,
  LCircleMarker,
  LMarker,
  LIcon,
  LTooltip,
  LControlZoom,
} from 'vue2-leaflet'
import { latLng, icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import SelectsV2 from '@/components/utils/SelectsV2.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import utils from '@/mixins/utils.js'

export default {
  name: 'CidadaosVisitados',
  directives: { mask },
  components: {
    LMap,
    LCircle,
    LTileLayer,
    LMarker,
    LIcon,
    LCircleMarker,
    LTooltip,
    LControlZoom,
    PulseLoader,
    Loader,
    Subtitle,
    TabelaCadastros,
    SelectsV2,
    DownloadFiles,
  },
  mixins: [utils],
  data() {
    return {
      enableSelect: '',
      iconSize: 64,
      zoom: 10,
      center: latLng(-15.2, -51.31),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      iconVerde: icon({
        iconUrl: require('@/assets/images/marcadores-mapa/pessoa-verde.svg'),
        iconSize: [32, 37],
        iconAnchor: [16, 37],
      }),
      iconVermelho: icon({
        iconUrl: require('@/assets/images/marcadores-mapa/pessoa-vermelho.svg'),
        iconSize: [32, 37],
        iconAnchor: [16, 37],
      }),
      tabsActive: 0,
      equipe: '',
      micro_area: '',
      cadastrosOriginais: [],
      cadastros: [],
      dadosResultadoMunicipio: {
        denominador: 0,
        numerador: 0,
        resultado: 0,
      },
      dadosResultadoEquipe: {
        denominador: 0,
        numerador: 0,
        resultado: 0,
      },
      dadosResultadoMicroArea: {
        denominador: 0,
        numerador: 0,
        resultado: 0,
      },
      loading: false,
      size: '40px',
      color: '#0D98BB',
      dadosDoResultado: [],
      cadastrosMapa: [],
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      setColor: null,
      visita_opcoes: [
        {
          visita: 'Todos',
        },
        {
          visita: 'Realizada',
        },
        {
          visita: 'Ausente',
        },
      ],
      visita: '',
      semZoom: false,
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    dynamicSize() {
      return [this.iconSize, this.iconSize * 1.15]
    },
    dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize * 1.15]
    },
    ultimaAtualizacaoSincronizadorC() {
      if (this.$store.getters['getSincronizadorC'] !== null) {
        return this.$store.getters['getSincronizadorC'].ultimaAtualizacao
          .split('/')
          .reverse()
          .join('-')
      }
      return null
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    async filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais
      if (vermelho === true) {
        data = Functions.exibirVermelhos(
          data,
          this.ultimaAtualizacaoSincronizadorC
        )
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(
          data,
          this.ultimaAtualizacaoSincronizadorC
        )
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
      let visita = this.visita
      if (this.visita === null) {
        this.visita = ''
        visita = {
          visita: 'Todos',
        }
      }
      if (visita !== '') {
        data = this.handleVisita(data, visita)
      } else {
      }

      this.cadastros = data
      await this.loadMap()
    },

    loadMap() {
      if (this.cadastros) {
        this.cadastrosMapa = this.cadastros.filter((item) => {
          return (
            item.lat !== '0' &&
            item.lat !== null &&
            item.lng !== '0' &&
            item.lng !== null
          )
        })
        setTimeout(() => {
          const cod_ibge = this.$store.state.cod_ibge
          const state = this.$store.state.cidade.split('-')[1].trim()

          // pega as coordenadas do municipio
          const countyCoordinates = mapa.find((item) => {
            return item.co_ibge === cod_ibge
          })

          // pega o zoom para o estado
          const coordinatesState = coordinates.find((item) => {
            return item.uf === state
          })
          const mapObject = this.$refs.map.mapObject

          mapObject.invalidateSize(true)
          // Faz com que não de zoom quando "semZoom" é true
          if (this.semZoom === false) {
            mapObject.setView(
              latLng(countyCoordinates.local[0], countyCoordinates.local[1]),
              coordinatesState.zoom + 4
            )
          }
          // Caso "semZoom" seja true o sistema reseta para false para o zoom
          // ocorrer nos outros filtros
          this.semZoom = false
        }, 500)
      } else {
        setTimeout(() => {
          const mapObject = this.$refs.map.mapObject
          mapObject.invalidateSize(true)
          mapObject.setView(this.center, 5)
        }, 500)
      }
    },

    handleVisita(data, event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      const visitado = event.visita

      let filtrado = data.filter((item) => {
        if (visitado === 'Todos') {
          return item
        } else if (visitado === 'Realizada') {
          return item.id_desfecho == '1'
        } else if (visitado === 'Ausente') {
          return item.id_desfecho == '3'
        } else {
          return item
        }
      })
      // Faz com que não de zoom quando esse filtro é ativado
      this.semZoom = true
      return filtrado
    },

    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.filtros(true, false)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = false
      }
      // Faz com que não de zoom quando esse filtro é ativado
      this.semZoom = true
    },

    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.filtros(false, true)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = false
      }
      // Faz com que não de zoom quando esse filtro é ativado
      this.semZoom = true
    },

    resetColor() {
      this.setColor = false
      this.exibirCadastrosVerdes = false
      this.exibirCadastrosVermelhos = false
    },

    iconColor(dt_ultima_visita, desfecho, lat, lng) {
      if (dt_ultima_visita !== null) {
        let diff = this.differenceOfDaysBetweenTwoDates(
          this.ultimaAtualizacaoSincronizadorC,
          dt_ultima_visita
        )
        if (diff > 30 || dt_ultima_visita == null || desfecho != 1) {
          return this.iconVermelho
        } else {
          return this.iconVerde
        }
      } else {
        return this.iconVerde
      }
    },

    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.tabsActive = 0
        this.visita = ''
        this.setColor = true
        this.equipe = event
        this.cadastros = []
        await this.buscarCadastrosPorEquipe()
        this.setarPercentualEquipe()
      } else {
        this.tabsActive = 0
        this.visita = ''
        this.setColor = true
        this.equipe = ''
        this.cadastros = []
        this.cadastrosOriginais = []
      }
    },

    async buscarCadastrosPorEquipe() {
      try {
        this.loading = true
        const response = await this.$api.get(
          `/app/cidadaos-visitados/${this.$store.state.cod_ibge}/equipe/${this.equipe.ine_esf_eap}`
        )
        if (response) {
          this.cadastros = response.data
          this.cadastrosOriginais = response.data
          this.filtros(
            this.exibirCadastrosVermelhos,
            this.exibirCadastrosVerdes
          )
        }
        this.loadMap()
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    async onChangeMicroArea(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.tabsActive = 0
      this.visita = ''
      this.setColor = true
      if (event !== null) {
        this.micro_area = event.micro_area
        await this.buscarCadastrosMicroArea()
        this.setarPercentualMicroArea()
      } else {
        this.cadastrosMapa = []
        this.cadastrosOriginais = []
        this.cadastros = []
        this.micro_area = ''
        await this.onChangeEquipe(this.equipe)
        setTimeout(() => {
          const mapObject = this.$refs.map.mapObject
          this.zoom = 5
          mapObject.invalidateSize(true)
          mapObject.setView(this.center, 5)
        }, 500)
      }
    },

    async buscarCadastrosMicroArea() {
      try {
        this.loading = true
        const response = await this.$api.get(
          '/app/cidadaos-visitados/' +
            this.$store.state.cod_ibge +
            '/equipe/' +
            this.equipe.ine_esf_eap +
            '/microarea/' +
            this.micro_area
        )
        if (response) {
          this.cadastros = response.data
          this.cadastrosOriginais = response.data
          this.filtros(
            this.exibirCadastrosVermelhos,
            this.exibirCadastrosVerdes
          )
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    setarPercentualMunicipio() {
      let res = Functions.percentualMunicipio(this.dadosDoResultado)
      this.dadosResultadoMunicipio.denominador = res.denominador
      this.dadosResultadoMunicipio.resultado = res.resultado
      this.dadosResultadoMunicipio.numerador = res.numerador
    },

    setarPercentualEquipe() {
      let res = Functions.percentualEquipe(
        this.dadosDoResultado,
        this.equipe.ine_esf_eap
      )
      this.dadosResultadoEquipe.denominador = res.denominador
      this.dadosResultadoEquipe.resultado = res.resultado
      this.dadosResultadoEquipe.numerador = res.numerador
    },

    setarPercentualMicroArea() {
      let res = Functions.percentualMicroArea(
        this.dadosDoResultado,
        this.equipe.ine_esf_eap,
        this.micro_area
      )
      this.dadosResultadoMicroArea.denominador = res.denominador
      this.dadosResultadoMicroArea.resultado = res.resultado
      this.dadosResultadoMicroArea.numerador = res.numerador
    },

    async init() {
      try {
        this.loading = true
        let response = await this.$api.get(
          `/app/v2/serie-historica/${this.$store.state.cod_ibge}/indicador/[20]`
        )
        if (response) {
          this.dadosDoResultado = response.data
          // dados do município
          this.setarPercentualMunicipio()

          // Enfermeiro, médico ...
          if (this.enableSelect == 2) {
            let equipe = this.$store.state.equipesV2.find((el) => {
              return el.ine_esf_eap == this.$store.state.nu_ine
            })
            if (equipe) {
              this.equipe = {
                ine_esf_eap: equipe.ine_esf_eap,
                no_equipe: equipe.no_esf_eap,
              }
              this.buscarCadastrosPorEquipe()
              this.setarPercentualEquipe()
            }
          }

          // ACS
          if (this.enableSelect == 3) {
            let equipe = this.$store.state.equipesV2.find((el) => {
              return el.ine_esf_eap == this.$store.state.nu_ine
            })
            if (equipe) {
              this.equipe = {
                ine_esf_eap: equipe.ine_esf_eap,
                no_equipe: equipe.no_esf_eap,
              }
              this.setarPercentualEquipe()
            }
            this.micro_area = this.$store.state.micro_area
            this.buscarCadastrosMicroArea()
            this.setarPercentualMicroArea()
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    // Formata os dados encontrados no mapa
    getRadius(desempenho) {
      const value = parseFloat(desempenho)
      const result = value / 30
      return result
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.micro_area,
        this.ultimaAtualizacaoSincronizadorC
      )
    },
  },
  created() {
    this.enableSelect = this.enableSelects()
    this.init()
  },
}
</script>

<style>
#cidadaos_visitados .mapa {
  z-index: 0;
}
#cidadaos_visitados .leaflet-container {
  z-index: 5;
}
#cidadaos_visitados .select-visita .vs__dropdown-menu {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  padding: 0px;
}
#cidadaos_visitados .select-visita .vs--searchable .vs__dropdown-toggle {
  padding: 5px;
}
#cidadaos_visitados .select-visita .v-select {
  width: 296px;
}
#cidadaos_visitados .select-visita .vs__dropdown-toggle {
  background-color: #fff;
}
</style>
